import { render, staticRenderFns } from "./Helps.vue?vue&type=template&id=305921aa"
import script from "./Helps.vue?vue&type=script&lang=js"
export * from "./Helps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports